/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ShareNetworkIcon20Light = forwardRef('ShareNetworkIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11 5a3 3 0 1 1 .68 1.902L7.858 9.085a2.998 2.998 0 0 1 0 1.83l3.822 2.183a3 3 0 1 1-.497.868l-3.785-2.163a3 3 0 1 1 0-3.606l3.785-2.163A2.996 2.996 0 0 1 11 5Zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM5 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm7 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z" })));
});
